import {
    addChannelItem,
    addManageInnerItem,
    changeChannelAccountDetails,
    changeChannelAccountName,
    changeChannelAccountStatus,
    changeChannelStatus,
    changeManageItemStatus,
    getAccount,
    getManageItem,
    initializeGroupItem,
    inviteGroupMembers,
    manageCheckBoxChanged,
    manageListChanged,
    navigate,
    saveChanges,
    toggleRightPanel,
} from "./alert-settings-api";

export const onToggleRightPanel = () => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { rightPanelExpanded } = alertSettings;
      toggleRightPanel({ dispatch, rightPanelExpanded });
    };
  };
  
  export const onCloseRightPanel = (pathname: string, history: any) => {
    return (dispatch: any, getState: any) => {
      navigate({ dispatch, pathname, history });
    };
  };

  export const onAddChannelItem = (accountType: string) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { channels } = alertSettings;
      addChannelItem({ dispatch, channels, accountType });
    };
  };

  export const onInitializeGroupItem = () => {
      const defaultGroupItem = initializeGroupItem();
      return defaultGroupItem;
  };

  export const onAddManageInnerItem = (itemType: string, itemId: string) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { manage } = alertSettings;
      addManageInnerItem({ dispatch, manage, itemType, itemId });
    };
  };

  export const onInviteGroupMemembers = (group: any) => {
    return (dispatch: any, getState: any) => {
      return inviteGroupMembers({ group });
    };
  };

  export const onChangeChannelAccountName = (name: any, accountType: string, index: number) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { channels } = alertSettings;
      changeChannelAccountName({ dispatch, channels, accountType, name, index });
    };
  };

  export const onChangeChannelAccountStatus = (status: any, accountType: string, accountId: string, history: any) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { channels } = alertSettings;
      changeChannelAccountStatus({ dispatch, channels, accountType, status, accountId, history });
    };
  };

  export const onChangeManageItemStatus = (status: any, itemType: string, itemId: string, history: any) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { manage } = alertSettings;
      changeManageItemStatus({ dispatch, manage, itemType, status, itemId, history });
    };
  };

  export const onGetAccount = (accountType: string, accountId: string, channels: any) => {
      const account = getAccount({ channels, accountId, accountType });
      if (account) {
        return JSON.parse(JSON.stringify(account));
      }
      return null;
  };

  export const onGetItem = (itemType: string, itemId: string, manage: any) => {
    const item = getManageItem({ manage, itemId, itemType });
    if (item) {
      return JSON.parse(JSON.stringify(item));
    }
    return null;
  };

  export const onSaveChanges = (alertSettingsType: string, updatedObj: any, pathname: string, history: any) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      saveChanges({ dispatch, alertSettings, alertSettingsType, updatedObj, pathname, history });
    };
  };

  export const onCancelChanges = (pathname: string, history: any) => {
    return (dispatch: any, getState: any) => {
      navigate({ pathname, history });
    }
  };

  export const onChangeChannelAccountDetails = (accountType: string, accountId: string, detailToChange: string) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { channels } = alertSettings;
      changeChannelAccountDetails({ dispatch, channels, accountType, detailToChange, accountId });
    };
  };

  export const onChangeChannelStatus = (channelType: string, history?: any) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { channels } = alertSettings;
      changeChannelStatus({ dispatch, channels, channelType, history });
    };
  };
  
  export const onManageCheckBoxChanged = (itemType: string, itemId: string) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { manage } = alertSettings;
      manageCheckBoxChanged({ dispatch, manage, itemType, itemId });
    };
  };

  export const onManageListChanged = (itemType: string, list: Array<any>) => {
    return (dispatch: any, getState: any) => {
      const alertSettings = getState().alertSettings;
      const { manage } = alertSettings;
      manageListChanged({ dispatch, manage, itemType, list });
    };
  };


// WEBPACK FOOTER //
// ./src/actions/alert-settings/alert-settings.tsx